import { Reveal } from "@/components/Reveal";

/**
 * Einheitlicher Abschnittskopf: Kicker in Orange, darunter eine Überschrift,
 * deren Schlusswort optional im Signaturverlauf steht.
 */
export const SectionHeading = ({
  eyebrow,
  title,
  accent,
  tail,
  lead,
  className = "max-w-2xl mb-14",
  align = "left",
}) => (
  <Reveal className={`${className} ${align === "center" ? "mx-auto text-center" : ""}`}>
    {eyebrow && (
      <p className="text-xs md:text-sm tracking-[0.25em] uppercase font-bold text-brand-orange mb-5">
        {eyebrow}
      </p>
    )}
    <h2 className="font-display font-bold tracking-tight text-3xl md:text-4xl lg:text-5xl leading-[1.02]">
      {title}
      {accent && <span className="gradient-text">{accent}</span>}
      {tail}
    </h2>
    {lead && (
      <p className="mt-6 text-base md:text-lg leading-relaxed text-white/55">
        {lead}
      </p>
    )}
  </Reveal>
);
